import { ModalKind, ModalsState } from '@/shared/types/modals';
/**
 * General modal actions
 */
export const PUSH_MODAL = 'MODALS/PUSH_MODAL';
export const POP_MODAL = 'MODALS/POP_MODAL';
export const RESET_MODALS = 'MODALS/RESET_MODALS';
export const UPDATE_MODAL = 'MODALS/UPDATE_MODAL';

const defaultState: ModalsState = [];

const reducer = (
  state = defaultState,
  { kind, type, props }: Partial<{ kind: ModalKind; type: string; props: unknown }>
) => {
  switch (type) {
    case PUSH_MODAL: {
      return [...state, { kind: kind as ModalKind, props }];
    }
    case POP_MODAL: {
      return [...state.filter((e, i) => i !== state.length - 1)];
    }
    case RESET_MODALS: {
      return [];
    }
    case UPDATE_MODAL: {
      if (state.length === 0) {
        return state;
      }
      return state.map((modal, i) =>
        i === state.length - 1
          ? { ...modal, props: { ...modal.props, ...(props as object) } }
          : modal
      );
    }
    default: {
      return state;
    }
  }
};

/**
 * Pushes current modal to be displayed
 * @param  {string} kind  a key in the modal hash defined in ModalConductors.js
 * @param  {object} props the individual modal's react props as a JS object
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pushModal = (kind: ModalKind, props?: any) => ({
  type: PUSH_MODAL,
  kind: kind as ModalKind,
  props,
});

export const popModal = () => ({ type: POP_MODAL });

export const resetModals = () => ({ type: RESET_MODALS });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateModal = (props: any) => ({ type: UPDATE_MODAL, props });

export default reducer;
